/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-04 11:07:30
 * @LastEditTime: 2022-01-29 18:37:32
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 对账详情
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/ReconciliationList/detail.jsx
 */
import {Button, Col, Modal, Table} from 'antd';
import React, { useState } from 'react'
import { dicPayChannel, dicPayType, liuShuiMeiJu, mapOrdrTpcd, mapPlatformreconciliationStatus, mapPlatformreconciliationType, mapRcnclRsltStcd, mapTradeType } from '../../../axios/dictionaries';
import { CustomCol, CustomRow } from '../../../components/Custom';
import DetailTitle from '../../../components/DetailTitle';
import ModalScrollContainer from '../../../components/ModalScrollContainer';
import { fetchPlatformRecordGet } from '../../../services/platformAccountingRecord';
import {findDict, formatTime, moneyAddComma} from '../../../utils';
import moment from "moment";
import FileUpload from "../../../components/FileUpload";

const PlatformAccountingRecordDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postGet(id)
    }
    const close = () => {
        setVisible(false)
    }

    const postGet = (id) => {
        setLoading(true)
        fetchPlatformRecordGet({id}).then(res => {
            setDetailData(res)
            if(res.attachList){
                this.fileUploadRef.setFileToState(res.attachList)
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const szRmbPayOrderSummaryDataOrderInfoColumns = [
        { title: "商户订单号", dataIndex: "merchantOrderNo"} ,
        { title: "交易时间", dataIndex: "tradeDateTime", render: (text) => formatTime(text)} ,
        { title: "订单金额", dataIndex: "orderAmount"} ,
        { title: "交易金额", dataIndex: "tradeAmount"} ,
        { title: "清算金额", dataIndex: "liquidationAmount"} ,
        { title: "手续费", dataIndex: "serviceCharge"} ,
        { title: "订单号", dataIndex: "orderNo"} ,
        { title: "银行流水号", dataIndex: "bankSerialNumber"} ,
        { title: "记账日期", dataIndex: "bookkeepingDate"} ,
        { title: "柜台代码", dataIndex: "counterCode"} ,
        { title: "创建时间", dataIndex: "createTime", render: (text) => formatTime(text)} ,
        { title: "发卡行/道 "  ,dataIndex:"issuer"} ,
        { title: "订单状态", dataIndex: "orderStatus"} ,
        { title: "支付卡种", dataIndex: "paymentCardType"} ,
        { title: "数字人民币对账单-汇 总数据id",dataIndex:"summaryDataId"} ,
        { title: "付款方户名", dataIndex: "tradeCardName"} ,
        { title: "付款方账号/户 号"  ,dataIndex:"tradeCardNumber"} ,
        { title: "交易类型", dataIndex: "tradeType" }
    ]
    const ylPayOrderSummaryDataOrderInfoColumns = [
        { title: '商户名称', dataIndex: 'merchantName', },
        { title: '交易日期时间', dataIndex: 'tradeDateTime', render: (text) => formatTime(text)},
        { title: '交易金额', dataIndex: 'tradeAmount', },
        { title: '实际支付金额', dataIndex: 'actualPaymentAmount', },
        { title: '清算金额', dataIndex: 'liquidationAmount', },
        { title: '手续费', dataIndex: 'serviceCharge', },
        { title: '商户号', dataIndex: 'merchantNumber', },
        { title: '商户订单号', dataIndex: 'merchantOrderNo', },
        { title: '银商订单号', dataIndex: 'silverMerchantOrderNo', },
        { title: '分店简称', dataIndex: 'branchStore', },
        { title: '卡类型', dataIndex: 'cardType', },
        { title: '子订单号', dataIndex: 'childOrderNo', },
        { title: '创建时间', dataIndex: 'createTime', render: (text) => formatTime(text)},
        { title: '发卡行', dataIndex: 'issuingBank', },
        { title: '商户优惠金额', dataIndex: 'merchantDiscountAmount', },
        { title: '其他优惠金额', dataIndex: 'otherDiscountAmount', },
        { title: '支付类型', dataIndex: 'payType', },
        { title: '付款附言', dataIndex: 'postscriptPayment', },
        { title: '参考号', dataIndex: 'referenceNumber', },
        { title: '备注信息', dataIndex: 'remark', },
        { title: '流水号', dataIndex: 'serialNumber', },
        { title: '终端号', dataIndex: 'terminalNumber', },
        { title: '第三方订单号', dataIndex: 'thirdPartyOrderNo', },
        { title: '交易卡号', dataIndex: 'tradeCardNumber', },
        { title: '交易日期', dataIndex: 'tradeDate', },
        { title: '交易时间', dataIndex: 'tradeTime' },
        { title: '退货订单号', dataIndex: 'returnGoodsOrderNo', },
        { title: '交易类型', dataIndex: 'tradeType', },
        { title: '钱包优惠金额', dataIndex: 'walletDiscountAmount', }
    ]
    const ylSharingPayOrderSummaryDataOrderInfoColumns = [
        { title: '商户名称', dataIndex: 'merchantName', },
        { title: '交易金额', dataIndex: 'tradeAmount', },
        { title: '手续费', dataIndex: 'serviceCharge', },
        { title: '交易净额', dataIndex: 'tradeNetAmount', },
        { title: '企业用户号', dataIndex: 'enterpriseUserNumber', },
        { title: '商户订单号', dataIndex: 'merchantOrderNo', },
        { title: '交易时间', dataIndex: 'tradingTime', render: (text) => formatTime(text)},
        { title: '划付中金额', dataIndex: 'transferInProgressAmount', },
        { title: '可划付金额', dataIndex: 'transferableAmount', },
        { title: '已划付金额', dataIndex: 'transferredAmount', },
        { title: '收单方代码', dataIndex: 'acquirerCode', },
        { title: '退货中金额', dataIndex: 'amountInReturn', },
        { title: '卡类型', dataIndex: 'cardType', },
        { title: '清算收单方代码', dataIndex: 'clearingAcquirerCode', },
        { title: '创建时间', dataIndex: 'createTime', render: (text) => formatTime(text)},
        { title: '客户号', dataIndex: 'customerNumber', },
        { title: '分账金额', dataIndex: 'dividedAmount', },
        { title: '清算日期', dataIndex: 'liquidationDate', },
        { title: '商户集团编号', dataIndex: 'merchantGroupNumber', },
        { title: '商户多应用类型', dataIndex: 'merchantMultiApplicationType', render: (text) => {}},
        { title: '机构编号', dataIndex: 'orgNo', },
        { title: '原交易参考号', dataIndex: 'originalReferenceNumber', },
        { title: '原交易金额', dataIndex: 'originalTradeAmount', },
        { title: '原交易日期', dataIndex: 'originalTradingTime', render: (text) => formatTime(text)},
        { title: '参考号', dataIndex: 'referenceNumber', },
        { title: '备注信息', dataIndex: 'remark', },
        { title: '可退货金额', dataIndex: 'returnableAmount', },
        { title: '已退货金额', dataIndex: 'returnedAmount', },
        { title: '流水号', dataIndex: 'serialNumber', },
        { title: '结算商户编号', dataIndex: 'settlementMerchantNumber', },
        { title: '银商订单号', dataIndex: 'silverMerchantOrderNo', },
        { title: '挂账流水标记', dataIndex: 'standingBookMark', },
        { title: '终端号', dataIndex: 'terminalNumber', },
        { title: '交易类型', dataIndex: 'tradeType', render: (text) => {
            return findDict(mapTradeType, text).title
        } },

    ]

    const hsbPayOrderSummaryDataOrderInfoColumns = [
        { title: '主订单编号', dataIndex: 'mainOrdrNo', width: 260 },
        { title: '支付流水号', dataIndex: 'ordrNo', width: 260 },
        { title: '交易日期', dataIndex: 'txnDt', render: (text) => {
                if (text) {
                    return moment(text).format('YYYY-MM-DD')
                }else{
                    return "";
                }
            }
        },
        { title: '交易时间', dataIndex: 'txnTm', },
        { title: '交易金额', dataIndex: 'txnamt', },
        { title: '手续费', dataIndex: 'hdCg', },
        { title: '创建时间', dataIndex: 'createTime', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '本行/微信/支付宝', dataIndex: 'lssubnkDsc', },
        { title: '市场商户编号', dataIndex: 'mktMrchId', },
        { title: '市场商户名称', dataIndex: 'mktMrchNm', },
        { title: '订单类型代码 ', dataIndex: 'ordrTpcd', render: (text) => {
            return findDict(mapOrdrTpcd, text).title
        } },
        { title: '借记卡等', dataIndex: 'pyCrdtpDsc', },
        { title: '卡号', dataIndex: 'pyrAccno', width: 150 },
        { title: '收款状态代码', dataIndex: 'rcnclRsltStcd', render: (text) => {
            return findDict(mapRcnclRsltStcd, text).title
        } },

    ]
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="对账详情" 
            width={950} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <DetailTitle title="租客" />
                    <CustomRow >
                        <CustomCol label="姓名">
                            <span style={{ paddingLeft:6 }}>{detailData.customerName}</span>
                        </CustomCol>
                        <CustomCol label="证据号码">
                            <span style={{ paddingLeft:6 }}>{detailData.credentialNumber}</span>
                        </CustomCol>
                        <CustomCol label="手机">
                            <span style={{ paddingLeft:6 }}>{detailData.customerPhone}</span>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="收款" />
                    <CustomRow>
                        <CustomCol label="交易金额">
                            <span style={{ paddingLeft:6 }}>{detailData.amount}</span>
                        </CustomCol>
                        <CustomCol label="交易渠道">
                            <span style={{ paddingLeft:6 }}>{findDict(dicPayChannel, detailData.payChannel).title }</span>
                        </CustomCol>
                        <CustomCol label="交易方式">
                            <span style={{ paddingLeft:6 }}>{findDict(dicPayType, detailData.payType).title }</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="交易状态">
                            <span style={{ paddingLeft:6 }}>{findDict(liuShuiMeiJu, detailData.status).title}</span>
                        </CustomCol>
                        <CustomCol label="交易时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.tradeTime)}</span>
                        </CustomCol>
                    </CustomRow>
                    {
                        detailData.tradeRecordPaylog instanceof Array && detailData.tradeRecordPaylog.length !== 0 ?
                            <Col>
                                <DetailTitle title="账单" />
                                <div className="tableBox">
                                    <div className="tableTitle">
                                        <div style={{ flex: 1 }}>应收日期</div>
                                        <div style={{ flex: 1 }}>房源</div>
                                        <div style={{ flex: 1 }}>账单名称</div>
                                        <div style={{ flex: 1 }}>账单周期</div>
                                        <div style={{ flex: 1 }}>应收金额（元）</div>
                                        <div style={{ flex: 1 }}>核销日期</div>
                                        <div style={{ flex: 1 }}>核销金额（元）</div>
                                        <div style={{ flex: 1 }}>优惠金额（元）</div>
                                    </div>
                                    <div className="tableBody">
                                        {
                                            detailData.tradeRecordPaylog.map((item, index) => {
                                                return (
                                                    <div className="tableBodyRow" key={item.id}>
                                                        <div style={{ flex: 1 }}>{item.mustPayDate ? moment(item.mustPayDate).format('YYYY-MM-DD') : null}</div>
                                                        <div style={{ flex: 1, flexDirection: "column" }}>
                                                            <div>
                                                                {item.roomNo ? item.roomNo : null}
                                                            </div>
                                                            <div>
                                                                {item.buildingName ? item.buildingName : null}
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            {item.billFeeName ? item.billFeeName : null}
                                                        </div>
                                                        <div style={{ flex: 1, flexDirection: "column" }}>
                                                            <div>
                                                                {item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}
                                                            </div>
                                                            <div>
                                                                {item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}
                                                            </div>
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            {item.billMoney ? moneyAddComma(item.billMoney) : null}
                                                        </div>
                                                        <div style={{ flex: 1 }}>{
                                                            item.createTime ? moment(detailData.createTime).format('YYYY-MM-DD') : null
                                                        }</div>
                                                        <div style={{ flex: 1, color: "red" }}>{
                                                            item.amount ? moneyAddComma(item.amount-(item.creditAmount==null?0:item.creditAmount)) : null
                                                        }</div>
                                                        <div style={{ flex: 1, color: "red" }}>{
                                                            item.amount ? moneyAddComma(item.creditAmount) : null
                                                        }</div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                            : null
                    }
                    <DetailTitle title="对账信息" />
                    <CustomRow divider>
                        <CustomCol label="对账状态">
                            <span style={{ paddingLeft:6 }}>{detailData.reconciliationState ? findDict(mapPlatformreconciliationStatus, detailData.reconciliationState).title:'未对账' }</span>
                        </CustomCol>
                        <CustomCol label="对账时间">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.reconciliationTime)}</span>
                        </CustomCol>
                        <CustomCol label="对账类型">
                            <span style={{ paddingLeft:6 }}>{findDict(mapPlatformreconciliationType, detailData.reconciliationType).title }</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="对账备注信息">
                            <span style={{ paddingLeft:6 }}>{detailData.reconciliationNote}</span>
                        </CustomCol>
                    </CustomRow>
                    <DetailTitle title="银联回执信息附件" />
                    <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="tradeRecord"  fileTypeList={[18]} isValueStyle />
                    {
                        detailData.szRmbPayOrderSummaryDataOrderInfoList && detailData.szRmbPayOrderSummaryDataOrderInfoList.length > 0 && (
                            <React.Fragment>
                                <DetailTitle title="关联数币订单明细数据" />
                                <Table 
                                    columns={szRmbPayOrderSummaryDataOrderInfoColumns}
                                    dataSource={detailData.szRmbPayOrderSummaryDataOrderInfoList}
                                />
                            </React.Fragment>
                        )
                    }
                    {
                        detailData.ylPayOrderSummaryDataOrderInfoList && detailData.ylPayOrderSummaryDataOrderInfoList.length > 0 && (
                            <React.Fragment>
                                <DetailTitle title="关联银联订单明细数据" />
                                <Table 
                                    columns={ylPayOrderSummaryDataOrderInfoColumns}
                                    scroll={{x:3000}}
                                    dataSource={detailData.ylPayOrderSummaryDataOrderInfoList}
                                />
                            </React.Fragment>
                        )
                    }
                    {
                        detailData.ylSharingPayOrderSummaryDataOrderInfoList && detailData.ylSharingPayOrderSummaryDataOrderInfoList.length > 0 && (
                            <React.Fragment>
                                <DetailTitle title="关联银联分账系统订单明细数据" />
                                <Table 
                                    columns={ylSharingPayOrderSummaryDataOrderInfoColumns}
                                    scroll={{x:3000}}
                                    dataSource={detailData.ylSharingPayOrderSummaryDataOrderInfoList}
                                />
                            </React.Fragment>
                        )
                    }
                    {
                        detailData.hsbPayOrderSummaryDataOrderInfoList && detailData.hsbPayOrderSummaryDataOrderInfoList.length > 0 && (
                            <React.Fragment>
                                <DetailTitle title="惠市宝对账的明细数据" />
                                <Table 
                                    columns={hsbPayOrderSummaryDataOrderInfoColumns}
                                    scroll={{x:2000}}
                                    dataSource={detailData.hsbPayOrderSummaryDataOrderInfoList}
                                />
                            </React.Fragment>
                        )
                    }
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default PlatformAccountingRecordDetail






// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/ReconciliationList/detail.jsx